import React, { useEffect, useRef, useState } from 'react'
import "./blogs.scss";
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';
import { axiosApi } from '../../../../_helper/api_helper';
 


const Blogs = () => {
    const carouselRef = useRef(null);

    const [blogsData, setBlogData] = useState([]);
    const [categoriesData, setCategories] = useState([]);
 
    const [activeButton, setActiveButton] = useState(null);
    useEffect(() => {
        blogsapi()
    }, [])
    const blogsapi = async () => {
        const response = await axiosApi.get(`/blogs`)
        setBlogData(response?.data)
    }
    useEffect(() => {
        categoriesGet();

    }, [])

    const categoriesGet = async () => {
        const response = await axiosApi.get("/occupation-skills");
        setCategories(response?.data)
    }
    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
        setActiveButton('left');
    }

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
        setActiveButton('right');
    }
    
    const extractDate = (timestamp) => {
        return timestamp.split('T')[0];
    };
    return (
        <>
            <div className="main-blog-home">
                <div className="home-page-blog">
                    <div className="home-blog-inner">
                        <div className="blog-inner-first">
                            <h3>Our Blog</h3>
                            <p>Get in-depth insight into recent trends and innovation in business and technology through well-researched articles by industry experts</p>
                        </div>
                        <div className="blog-inner-second">
                            <div className="inner-button" >
                                <div className="inner-button-carousel" >
                                    <button className={`carousel-button left ${activeButton === 'left' ? 'active' : ''}`} onClick={scrollLeft}><WestIcon className='icon-left' /></button>
                                    <button className={`carousel-button right ${activeButton === 'right' ? 'active' : ''}`} onClick={scrollRight}><EastIcon className='icon-left' /></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className="slick-carousel-blogs" >
                    <div className="slick-container">
                        {blogsData?.length > 0 &&
                            <div>
                                <Carousel
                                    ref={carouselRef}
                                    additionalTransfrom={0}
                                    arrows={false}
                                    autoPlaySpeed={3000}
                                    centerMode={false}
                                    className=""
                                    containerClass="carousel-container"
                                    customButtonGroup={<button></button>}
                                    dotListClass=""
                                    draggable
                                    focusOnSelect={false}
                                    infinite
                                    itemClass=""
                                    keyBoardControl
                                    minimumTouchDrag={80}
                                    renderButtonGroupOutside={false}
                                    renderDotsOutside={false}
                                    responsive={{
                                        desktop: {
                                            breakpoint: {
                                                max: 3000,
                                                min: 1024
                                            },
                                            items: 3
                                        },
                                        mobile: {
                                            breakpoint: {
                                                max: 464,
                                                min: 0
                                            },
                                            items: 2
                                        },
                                        tablet: {
                                            breakpoint: {
                                                max: 1024,
                                                min: 464
                                            },
                                            items: 2
                                        }
                                    }}
                                    showDots={false}
                                    sliderClass=""
                                    slidesToSlide={1}
                                    swipeable
                                >
                                    {blogsData.map((item, index) => (
                                        <>
                                            <div className='blogs-container'>
                                                <div className="blogs-container-inner">
                                                    <div key={index} className='carousel-img'>

                                                        <img src={`${axiosApi.defaults.baseURL}${item?.blog_img}`} alt="" />

                                                    </div>
                                                    <div className="blog-category-container">
                                                        <div className='blog-category'>{item?.category}</div>
                                                        <div className='blog-date'>{extractDate(item?.created_at)}</div>
                                                    </div>


                                                    <div className='blog-title'>{item?.title}</div>
                                                    <div className='blog-para'>{(item?.content).slice(0, 50)}...</div>
                                                    <div className='blog-button m'><Link style={{ color: "red", fontWeight: "400" }} to={`/blog/${item?.id}`}>Read more</Link>  </div>

                                                </div>

                                            </div>

                                        </>

                                    ))}
                                </Carousel>
                            </div>
                        }
                    </div>
                    <div className='see-more-blog-button mt-3'>
                        <Link to='/blog'>
                            <button>View All</button>
                            {/* <button className=''> <span className='see-more-blog'><ArrowOutwardIcon /></span> </button> */}
                        </Link>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Blogs